<template>
    <div
        id="Container"
        class="widget-container widget-teaser background--card"
    >
        <a
            href="#"
            @click.prevent="closeSelf"
            class="close"
        >
            <svg-rndr svg="close.svg" />
        </a>
        <div class="widget-contents DialogContent DialogContent--fullheight">
            <div class="widget-contents__inner DialogContentInner">
                <div class=" d-flex justify-content-center mb-4">
                    <svg-rndr
                        svg="warning.svg"
                        :width="170"
                    />
                </div>
                <div class="form-row justify-content-center mb-4 text-center">
                    <div class="col-md-12">
                        <h1>{{ teaserMessage }}</h1>

                        <p v-translate>An email has been sent showing your interest in upgrading, a Learn To Trade Representative will contact you shortly to discuss your upgrade options.</p>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <flash-message></flash-message>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import widgetMixin from '@M/widgets/dialog';

export default {
    mixins: [widgetMixin],
    mounted() {
        // State won't have persisted from top-level page, but we can receive it through the widget framework settings key and manually update the state
        this.setSelectedUpgrade(this._widgetInstance.privateSettings.selectedUpgrade);
        this.$store.dispatch('Widget/sendTeaserEmail');
    },
    methods: {
        ...mapMutations('Widget', [
            'setSelectedUpgrade'
        ]),
    },
    computed: {
        teaserMessage() {
            return this.$store.state.Widget.selectedUpgrade.message ?
                this.$store.state.Widget.selectedUpgrade.message
                : this.$gettext('In order to upgrade to this subscription level, you will need to be on an advanced training programme with Learn To Trade.');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/UpgradeSubscriptionTeaser.vue